export default "__VITE_ASSET__COF9wmMN__"